// THIS FILE WAS AUTO GENERATED, UPDATE THE i18n FILES

import { HBinput, i18nLoad } from "@cervval.js/i18n/src/i18n.tools";

export type I18nType = {
    editItemFormDialog: {
        confirm: {
            update: string
        },
        label: {
            create: string,
            update: string
        }
    },
    logMessage: {
        atDate: string,
        createAgendaItem: (input: { items: HBinput, target: HBinput }) => string,
        deleteAgendaItem: (input: { items: HBinput }) => string,
        item: string,
        items: string,
        moveAgendaItem: (input: { items: HBinput, targetColumn: HBinput, targetDate: HBinput }) => string,
        onColumn: string,
        resizeFinishAgendaItem: (input: { items: HBinput, target: HBinput }) => string,
        resizeStartAgendaItem: (input: { items: HBinput, target: HBinput }) => string
    },
    nextBtn: string,
    pickIntervalBtn: string,
    previousBtn: string
};

const i18n_en = require("./_en.i18n"); // hash_en=8283383689921230#
const i18n_fr = require("./_fr.i18n"); // hash_fr=7255216186821005#

/** @returns the i18n for provided lang (fallback on app.lang if i18n not found for lang) */
export function i18n(lang?: string): I18nType {
    return i18nLoad<I18nType>(lang, ["en", "fr"], (langToLoad: string) => {
        switch (langToLoad) {
            case "en": return i18n_en;
            case "fr": return i18n_fr;
            default:
        }
        return null;
    });
}